export default __webpack_public_path__ + "static/media/pnsv_stand_Lala.1d7b301b.png";